import { Fragment } from 'react';
import Hero from '../../components/hero/hero';
import About from '../../components/about/about';
import Navbar from '../../components/Navbar/Navbar'
import Scrollbar from '../../components/scrollbar/scrollbar';
import Practice from '../../components/Practice';
import Footer from '../../components/footer/Footer';
import Testimonial from '../../components/Testimonial/Testimonial';
import Consultinencey from '../../components/Consultinencey/Consultinencey';
import SEO from '../../components/SEO';
import abimg from '../../images/about/about3.jpg'

const HomePage = () => {
    return (
        <Fragment>
            <SEO 
                title="Wilson Tamuka Attorneys | Zimbabwean Law Firm | Harare Legal Services"
                description="Wilson Tamuka Attorneys is a full legal service firm, Locally and Internationally offering expert legal services in commercial law, property law, litigation, notarial services, mining law, data privacy, and cyber law. Registered with the Law Society of Zimbabwe."
                keywords="Zimbabwe lawyers, Harare attorneys, commercial law Zimbabwe, property law Harare, litigation lawyers Zimbabwe, notarial services, corporate advisory Zimbabwe, conveyancing Zimbabwe, mining law, data privacy Zimbabwe, POTRAZ compliance, cyber law Zimbabwe, estate planning, legal services Harare"
                canonical="https://wtafirm.co.zw/"
            />
            <Navbar hclass={'wpo-header-style-2'} topbarNone={'topbar-none'} />
            <Hero />
            <About abimg={abimg}/>
            <Practice />
            <Testimonial />
            <Consultinencey />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;